export const changeOfSupplierSchema = {
  title: 'Change of Supplier',
  type: 'object',
  properties: {
    mpan_core: {
      type: 'string',
      title: 'MPAN Core',
    },
    supply_start_date: {
      type: 'string',
      format: 'date',
      title: 'Supply Start Date',
    },
    erroneous_switch_resolution_indicator: {
      type: 'boolean',
      title: 'Erroneous Switch Resolution Indicator',
      default: false,
    },
    change_of_occupancy_indicator: {
      type: 'boolean',
      title: 'Change of Occupancy Indicator',
      default: false,
    },
    metering_service_mpid: {
      type: 'string',
      title: 'Metering Service MPID',
    },
    ms_contract_reference: {
      type: 'string',
      title: 'MS Contract Reference',
    },
    data_service_mpid: {
      type: 'string',
      title: 'Data Service MPID',
    },
    ds_contract_reference: {
      type: 'string',
      title: 'DS Contract Reference',
    },
    mdr_mpid: {
      type: 'string',
      title: 'MDR MPID',
    },
    consent_granularity: {
      type: 'string',
      title: 'Consent Granularity',
      enum: ['H', 'D', 'M', 'N'],
      enumNames: ['H - Hourly', 'D - Daily', 'M - Monthly', 'N - None'],
    },
    fall_back_read_frequency: {
      type: 'string',
      title: 'Fall Back Read Frequency',
      enum: ['S', 'H', 'D', 'M'],
      enumNames: ['S - Settlement', 'H - Hourly', 'D - Daily', 'M - Monthly'],
    },
  },
  required: [
    'mpan_core',
    'supply_start_date',
    'metering_service_mpid',
    'data_service_mpid',
    'consent_granularity',
    'fall_back_read_frequency',
  ],
};

export const changeOfSupplierUISchema = {
  mpan_core: {
    'ui:placeholder': 'Select MPAN (non-Live status only)',
  },
  supply_start_date: {
    'ui:widget': 'date',
    'ui:placeholder': 'Select supply start date',
    'ui:help': 'Domestic: at least 1 working day in the future. Non-domestic: at least 2 working days.',
  },
  erroneous_switch_resolution_indicator: {
    'ui:widget': 'select',
    'ui:placeholder': 'Select value',
  },
  change_of_occupancy_indicator: {
    'ui:widget': 'select',
    'ui:placeholder': 'Select value',
  },
  metering_service_mpid: {
    'ui:placeholder': 'Enter Metering Service MPID (e.g. EMEB)',
  },
  ms_contract_reference: {
    'ui:placeholder': 'Enter MS Contract Reference',
  },
  data_service_mpid: {
    'ui:placeholder': 'Enter Data Service MPID (e.g. EMEB)',
  },
  ds_contract_reference: {
    'ui:placeholder': 'Enter DS Contract Reference',
  },
  mdr_mpid: {
    'ui:placeholder': 'Enter MDR MPID (e.g. MDRM)',
  },
  consent_granularity: {
    'ui:placeholder': 'Select Consent Granularity',
  },
  fall_back_read_frequency: {
    'ui:placeholder': 'Select Fall Back Read Frequency',
  },
  'ui:order': [
    'mpan_core',
    'supply_start_date',
    'erroneous_switch_resolution_indicator',
    'change_of_occupancy_indicator',
    'metering_service_mpid',
    'ms_contract_reference',
    'data_service_mpid',
    'ds_contract_reference',
    'mdr_mpid',
    'consent_granularity',
    'fall_back_read_frequency',
  ],
};
